import React, { Component } from "react";
import styles from "./Popup.module.scss";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import { withRouter } from "react-router-dom";
import { DateInput, Day, Week } from "@idui/react-date-components";
import { addDays, addMonths, addWeeks, differenceInDays, differenceInMonths, differenceInWeeks, format, parse, parseISO, toDate } from "date-fns";
import colors from "../../assets/idui_colours/colors.json"
import colorsdark from "../../assets/idui_colours/colorsdark.json"
import Button from '../UI/Button/Button';
import Icon from "../../components/UI/Icon/Icon";
import { onCalendarIconClick } from "../../utils/SharedUtils";
import { Dropdown } from "semantic-ui-react";

var classNames = require("classnames");

const repeatAvailabilityOptions = [
  "Daily",
  "Weekly",
  "Monthly"
]

const weekdays = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
]
const repeatTypeData = {
  "Daily": {
    "repeatUnit": "day",
    "minRepeatCount": 1,
    "maxRepeatCount": 180
  },
  "Weekly": {
    "repeatUnit": "week",
    "minRepeatCount": 1,
    "maxRepeatCount": 26
  },
  "Monthly": {
    "repeatUnit": "month",
    "minRepeatCount": 1,
    "maxRepeatCount": 6
  }
}

class RepeatModal extends Component {
  constructor(props) {
    super(props);

    const daysOfWeek = []
    const parsedFromDate = this.props.dateFrom ? format(parse(this.props.dateFrom, 'dd/MM/yyyy', new Date()), 'dd/MM/yy') : format(new Date(), 'dd/MM/yy')
    const parsedEndDate = this.props.dateTo ? format(parse(this.props.dateTo, 'dd/MM/yyyy', new Date()), 'dd/MM/yy') : parsedFromDate

    this.state = {
      showPopup: false,
      startDate: parsedFromDate,
      endDate: parsedEndDate,
      repeatCount: this.props.repeatCount ? this.props.repeatCount : 1,
      monthlyRepeatStartDay: this.props.dateOfMonth ? this.props.dateOfMonth : 1,
      daysOfWeek: this.props.daysOfWeek ? this.props.daysOfWeek : daysOfWeek,
      selectedRepeatOption: this.props.seriesType ? this.props.seriesType : repeatAvailabilityOptions[0],
      colors: colors,
    };
  }
  componentDidMount() {
    const theme = window.localStorage.getItem("displayPreference");
    if (theme === "dark") {
      this.setState({ colors: colorsdark });
    } else {
      this.setState({ colors: colors }); // Default colors
    }
  }

  componentWillUnmount() {
    this.setState({ showPopup: false });
  }

  onSave = () => {
    const repeatPayload = {
      dateFrom: this.state.startDate,
      dateTo: this.state.endDate,
      seriesType: this.state.selectedRepeatOption,
      daysOfWeek: this.state.daysOfWeek,
      dateOfMonth: this.state.monthlyRepeatStartDay,
      repeatCount: this.state.repeatCount
    }
    this.props.onSave(repeatPayload)
    this.props.onClose()
  }

  dateInputWeekRender = () => {
    return (weekDays) => (
      <Week>
        {["Su", "M", "Tu", "W", "Th", "F", "Sa"].map((item) => (
          <Day key={item}>{item}</Day>
        ))}
      </Week>
    );
  };

  handleRadioChange = (e) => {
    const selectedOption = e.target.value
    const daysOfWeek = {}
    weekdays.forEach((e) => daysOfWeek[e] = false)
    switch (selectedOption) {
      case "Weekends":
        weekdays.slice(5, 7).forEach((day) => daysOfWeek[day] = true)
        break;
      case "Weekdays":
        weekdays.slice(0, 5).forEach((day) => daysOfWeek[day] = true)
        break;
      default:
        break;
    }
    this.setState({
      selectedRepeatOption: selectedOption,
      daysOfWeek,
    })
  }

  handleStartDateChange() {
    const startDateObj = parse(this.state.startDate, 'dd/MM/yy', new Date());
    if (this.state.selectedRepeatOption === "Daily") {
      this.setState({ endDate: format(addDays(startDateObj, this.state.repeatCount - 1), 'dd/MM/yy') });
    }
    else if (this.state.selectedRepeatOption === "Weekly") {
      this.setState({ endDate: format(addDays(startDateObj, this.state.repeatCount * 7 - 1), 'dd/MM/yy') });
    }
    else if (this.state.selectedRepeatOption === "Monthly") {
      this.setState({ endDate: format(addMonths(startDateObj, this.state.repeatCount), 'dd/MM/yy') });
    }
  }
  handleEndDateChange() {
    const startDateObj = parse(this.state.startDate, 'dd/MM/yy', new Date());
    const endDateObj = parse(this.state.endDate, 'dd/MM/yy', new Date());

    if (this.state.selectedRepeatOption === "Daily") {
      this.setState({ repeatCount: differenceInDays(endDateObj, startDateObj) + 1 });
    }
    else if (this.state.selectedRepeatOption === "Weekly") {
      this.setState({ repeatCount: differenceInWeeks(endDateObj, startDateObj) + 1 });
    }
    else if (this.state.selectedRepeatOption === "Monthly") {
      this.setState({ repeatCount: differenceInMonths(endDateObj, startDateObj) + 1 });
    }
  }
  handleRepeatCountChange() {
    const startDateObj = parse(this.state.startDate, 'dd/MM/yy', new Date());
    if (this.state.selectedRepeatOption === "Daily") {
      this.setState({ endDate: format(addDays(startDateObj, this.state.repeatCount - 1), 'dd/MM/yy') });
    }
    else if (this.state.selectedRepeatOption === "Weekly") {
      this.setState({ endDate: format(addDays(startDateObj, this.state.repeatCount * 7 - 1), 'dd/MM/yy') });
    }
    else if (this.state.selectedRepeatOption === "Monthly") {
      this.setState({ endDate: format(addMonths(startDateObj, this.state.repeatCount), 'dd/MM/yy') });
    }
  }
  parseDateString(dateString) {
    return parse(dateString, 'dd/MM/yy', new Date());
  }
  ordinal = (number) => {
    const suffixes = {
      one: "st",
      two: "nd",
      few: "rd",
      other: "th"
    };
    const suffix = suffixes[new Intl.PluralRules("en", {
      type: "ordinal"
    }).select(number)];
    return (number + suffix);
  }
  render() {
    if (this.props.isVisible) {
      document.body.classList.add("popup-mode");
    } else {
      document.body.classList.remove("popup-mode");
    }

    let CloseAlertControls = classNames(
      "tileBg3 " + styles.closeAlertControls,
      this.props.className,
      {
        [styles.visible]: this.props.isVisible,
      },
      styles.repeatModalContainer
    );

    const dateFormat = "dd/MM/yy";
    const today = format(new Date(), dateFormat);

    return (
      <Wrapper>
        <div>
          <div className={CloseAlertControls}>
            <div className={styles.closeButton}>
              <div className={styles.headingText}>
                <span>Recurrence</span>
              </div>
              <button
                className={`${styles.closeAlertControls__btn} ${styles['-close']}`}
                onClick={this.props.onClose}
              >
              </button>
            </div>
            <div className={styles.contents}>
              <div>
                <div className={styles.section}>
                  <div className={styles.row}>
                    <label>Start:</label>
                    <div onClick={() => onCalendarIconClick("repeatDateStartField")}>
                      <DateInput
                        readOnly={true}
                        isDateDisabled={(date) => date < new Date().setHours(0, 0, 0, 0)}
                        outputFormat="DD/MM/YY"
                        id="repeatDateStartField"
                        renderWeek={this.dateInputWeekRender()}
                        className="repeatSelectStyle repeatDateSelect"
                        onChange={(newDate) => {
                          this.setState({ startDate: newDate }, () => {
                            this.handleStartDateChange();
                          });
                        }
                        }
                        value={this.state.startDate || today}
                        isClearable={false}
                        required
                        colors={this.state.colors}
                        rightAddon={<Icon
                          icon="icon_minicalIcon"
                        />
                        }
                      />
                    </div>

                  </div>
                  <div className={styles.row + " " + `selectionDropdownContainer seriesType`}>
                    <label>Repeat:</label>
                    <Dropdown
                      compact
                      selection
                      options={repeatAvailabilityOptions.map((e) => ({ key: e, text: e, value: e }))}
                      defaultValue={this.state.selectedRepeatOption}
                      icon={<Icon icon="icon_arrowDownSmall" name="arrowIcon" />}
                      onChange={(event, data) => {
                        this.setState({
                          selectedRepeatOption: data.value,
                        }, () => {
                          this.setState({
                            repeatCount: repeatTypeData[this.state.selectedRepeatOption]["minRepeatCount"]
                          }, () => {
                            this.handleRepeatCountChange();
                          })

                        });
                      }}
                    />
                  </div>
                  <div className={styles.adaptableContainer}>
                    <div className={styles.row + " " + `selectionDropdownContainer adaptableSpan`}>
                      <span>
                        <label>For:</label>
                        <Dropdown
                          compact
                          floating
                          selection
                          text={this.state.repeatCount && this.state.repeatCount + " " + repeatTypeData[this.state.selectedRepeatOption]["repeatUnit"] + `(s)`}
                          options={Array.from({ length: repeatTypeData[this.state.selectedRepeatOption]["maxRepeatCount"] - repeatTypeData[this.state.selectedRepeatOption]["minRepeatCount"] + 1 }, (_, i) => repeatTypeData[this.state.selectedRepeatOption]["minRepeatCount"] + i).map((e) => ({ key: e, text: e, value: e }))}
                          defaultValue={repeatTypeData[this.state.selectedRepeatOption]["minRepeatCount"]}
                          icon={<Icon icon="icon_arrowDownSmall" name="arrowIcon" />}
                          onChange={(event, data) => {
                            this.setState({
                              repeatCount: data.value
                            }, () => {
                              this.handleRepeatCountChange();
                            }
                            );
                          }
                          }
                        />
                      </span>
                      <span>
                        <label>End:</label>
                        <div onClick={() => onCalendarIconClick("repeatDateEndField")}>
                          <DateInput
                            readOnly={true}
                            isDateDisabled={(date) => date <
                              this.parseDateString(this.state.startDate)
                              ||
                              date > addMonths(this.parseDateString(this.state.startDate), 6)
                            }
                            outputFormat="DD/MM/YY"
                            id="repeatDateEndField"
                            renderWeek={this.dateInputWeekRender()}
                            className="repeatSelectStyle repeatDateSelect"
                            onChange={(newDate) => this.setState({ endDate: newDate }, () => {
                              this.handleEndDateChange();
                            }
                            )}
                            value={this.state.endDate || today}
                            isClearable={false}
                            required
                            colors={this.state.colors}
                            rightAddon={<Icon
                              icon="icon_minicalIcon"
                            />
                            }
                          />
                        </div>

                      </span>
                    </div>

                  </div>
                  {this.state.selectedRepeatOption === "Weekly" &&
                    <form onSubmit={(e) => e.preventDefault()}>
                      <fieldset>
                        <div className={styles.row + " " + `weekDayButtonContainer`}>
                          <label>On: </label>
                          {weekdays.map((e) => {
                            return (
                              <Button
                                key={e}
                                styles={this.state.daysOfWeek.includes(e) && `selectedWeekDay`}
                                buttonClick={() => {
                                  if (this.state.daysOfWeek.includes(e)) {
                                    this.setState({
                                      daysOfWeek: this.state.daysOfWeek.filter((day) => day !== e)
                                    })
                                  }
                                  else {
                                    this.setState((prevState) => ({
                                      daysOfWeek: [...prevState.daysOfWeek, e]
                                    }))
                                  }
                                }}
                                content={e[0]}
                              >
                              </Button>
                            )
                          })}
                        </div>
                      </fieldset>
                    </form>
                  }
                  {
                    this.state.selectedRepeatOption === "Monthly" &&
                    <div className={styles.row + " selectionDropdownContainer"}>
                      <label>Starting on of every month: </label>
                      <Dropdown
                        compact
                        selection
                        text={this.ordinal(this.state.monthlyRepeatStartDay)}
                        options={Array.from({ length: 31 }, (_, i) => i + 1).map((e) => ({ key: e, text: e, value: e }))}
                        defaultValue={this.state.monthlyRepeatStartDay ? this.state.monthlyRepeatStartDay : 1}
                        icon={<Icon icon="icon_arrowDownSmall" name="arrowIcon" />}
                        onChange={(event, data) => {
                          this.setState({
                            monthlyRepeatStartDay: data.value
                          });
                        }}
                      />
                    </div>
                  }
                  <div className={styles.row + " " + styles.adaptableContainer}>
                    <span className="repeatSummaryMessage">
                      Occurs
                      <span className="MessageText600"> for {this.state.repeatCount} {repeatTypeData[this.state.selectedRepeatOption]["repeatUnit"]}(s) </span>

                      {/* weekly recurrence */}
                      {
                        this.state.selectedRepeatOption === "Weekly" &&
                        <span>
                          {this.state.daysOfWeek.length > 0 && (
                            <span className="MessageText600">on </span>
                          )}
                          <span className="MessageText600">
                            {new Intl.ListFormat('en', { style: 'long', type: 'conjunction' }).format(
                              this.state.daysOfWeek.map((day) => day.slice(0, 3))
                            )}
                          </span>
                          {" starting "}
                          <span className="MessageText600">
                            {format(this.parseDateString(this.state.startDate), 'dd MMMM yyyy')}
                          </span>
                          {" ending "}
                          <span className="MessageText600">
                            {this.state.endDate
                              ? format(this.parseDateString(this.state.endDate), 'dd MMMM yyyy')
                              : format(this.parseDateString(today), 'dd MMMM yyyy')}
                          </span>
                        </span>
                      }

                      {/* daily recurrence */}
                      {
                        this.state.selectedRepeatOption === "Daily" && (
                          <span>
                            {" starting "}
                            <span className="MessageText600">
                              {format(this.parseDateString(this.state.startDate), 'dd MMMM yyyy')}
                            </span>
                            {" until "}
                            <span className="MessageText600">
                              {this.state.endDate
                                ? format(this.parseDateString(this.state.endDate), 'dd MMMM yyyy')
                                : format(this.parseDateString(today), 'dd MMMM yyyy')}
                            </span>
                          </span>
                        )
                      }
                      {/* monthly recurrence */}
                      {
                        this.state.selectedRepeatOption === "Monthly" && (
                          <span>
                            {" starting on the "}
                            <span className="MessageText600">
                              {this.ordinal(this.state.monthlyRepeatStartDay)}
                            </span>
                            {" of every month from "}
                            <span className="MessageText600">
                              {format(this.parseDateString(this.state.startDate), 'dd MMMM yyyy')}
                            </span>
                            {" ending on "}
                            <span className="MessageText600">
                              {this.state.endDate
                                ? format(this.parseDateString(this.state.endDate), 'dd MMMM yyyy')
                                : today}
                            </span>
                          </span>
                        )
                      }
                    </span>
                  </div>
                </div>
                <div className={styles.row + " " + styles.spaceBetweenRow + " footerButtonContainer"}>
                  <Button
                    buttonClick={() => { this.props.onClose() }}
                    content="Back"
                    styles="footerButton"
                  >
                  </Button>
                  <Button
                    styles="footerButton saveBtnStyle"
                    buttonClick={this.onSave}
                    content="Save"
                  >
                  </Button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}

export default withRouter(RepeatModal);
